import barba from '@barba/core';
//import barbaPrefetch from '@barba/prefetch';
import { TweenMax } from "gsap";
import 'gsap-then';
import { BrowserEvents, loadingBar, menuWrapper } from './constants';
import { enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6';

;(function($) {

	// ---------- Helpers ----------

	function scrollPosition() {

		const root = document.documentElement;
		const body = document.body;

		const scrollTop = window.pageYOffset || root.scrollTop || body.scrollTop || 0;
		const scrollLeft = window.pageXOffset || root.scrollLeft || body.scrollLeft || 0;

		const clientTop = root.clientTop || body.clientTop || 0;
		const clientLeft = root.clientLeft || body.clientLeft || 0;

		return {
			scrollTop: scrollTop,
			scrollLeft: scrollLeft,
			clientTop: clientTop,
			clientLeft: clientLeft
		};
	}

	function elementPosition(element) {

		const rect = element.getBoundingClientRect();

		const scroll = scrollPosition();

		return {
			top: Math.round(rect.top + scroll.scrollTop - scroll.clientTop),
			left: Math.round(rect.left + scroll.scrollLeft - scroll.clientLeft),
			height: rect.height,
			width: rect.width,
		};
	}

	function wait(delay, value) {
		return new Promise(resolve => setTimeout(resolve, delay, value));
	}

	function replaceBodyClasses(next) {

		const parser = new DOMParser();
		const newPage = parser.parseFromString(next.html, "text/html");
		const newBody = newPage.querySelector('body');

		document.body.className = newBody.getAttribute('class');

		if(typeof gtag === 'function') {

			gtag('config', 'UA-38104400-31', {
				'page_title': newPage.querySelector('head title').textContent,
				'page_path': window.location.pathname
			});
		}
	}

	// ---------- Barba Initialisation ----------

	if(document.body.classList.contains('woocommerce-page') && !document.body.classList.contains('post-type-archive-product')) {

		$('.main-wrapper').animsition({
			inClass: 'fade-in',
			outClass: 'fade-out',
			inDuration: 600,
			outDuration: 400,
			loading: false,
			linkElement: 'a:not([target="_blank"]):not([href*="#"]):not([href^="mailto:"]):not([href^="tel:"]):not(.void-link):not([data-lity]):not([href=""]):not([download])',
		}).on('animsition.inStart', () => {
			$(document).trigger(BrowserEvents.barba.enter);
		}).on('animsition.inEnd', () => {
			loadingBar.classList.remove('active');
			$('.header-wrapper').addClass('active');
		}).on('animsition.outStart', () => {
			loadingBar.classList.add('active');
		});
	}
	else {

		//barba.use(barbaPrefetch);

		barba.init({
			prevent: ({ el }) => !$(el).is('a:not([target="_blank"]):not([href*="#"]):not([href^="mailto:"]):not([href^="tel:"]):not(.void-link):not([data-lity]):not([download]):not([href=""]):not([href*="shop"]:not([href$="shop/"])):not([hreflang])'),
			transitions: [{
				name: 'content-sections-transition',
				sync: true,
				from: {
					custom: (data) => (typeof data.trigger !== 'string' && data.trigger.parentNode.classList.contains('next-page-section'))
				},
				to: {
					namespace: ['content-sections', 'shop-page']
				},
				appear: async(data) => {
					$(document).trigger(BrowserEvents.barba.enter);
					$('.header-wrapper').addClass('active');
				},
				enter: async(data) => {
					data.next.container.classList.add('from-barba');

					$(document).one(BrowserEvents.barba.transition, () => {
						loadingBar.classList.remove('active');
						$(document).trigger(BrowserEvents.barba.enter);
						$('.header-wrapper').addClass('active');
					});

					return true;
				},
				leave: async(data) => {

					$('.header-wrapper').removeClass('active small');

					data.next.container.classList.add('invisible');
					loadingBar.classList.add('active');

					const link = data.trigger.parentNode;
					const windowWidth = window.innerWidth;
					const windowHeight = window.innerHeight;

					const position = elementPosition(link);
					const scroll = scrollPosition();

					const clone = link.cloneNode(true);
					const image = clone.querySelector('.parallax-image');

					clone.classList.add('clone');
					clone.classList.remove('active');

					TweenMax.set(clone, { ...position });

					document.body.appendChild(clone);
					document.body.classList.add('leaving');

					link.classList.add('invisible');

					if(image) {

						TweenMax.to(image, 1, {
							x: 0,
							y: 0,
							autoRound: false,
							ease: Power4.easeInOut,
						});
					}

					await TweenMax.to(clone, 1, {
						x: -position.left,
						y: scroll.scrollTop - position.top,
						width: window.innerWidth,
						maxWidth: window.innerWidth,
						height: window.innerHeight,
						padding: 0,
						autoRound: false,
						ease: Power4.easeInOut,
					});

					await wait(100);

					return true;
				},
				after: async(data) => {

					window.scrollTo(0, 0);

					data.next.container.classList.remove('invisible');

					replaceBodyClasses(data.next);

					$('.clone').remove();

					$(document).trigger(BrowserEvents.barba.transition);

					return true;
				}
			}, {
				name: 'default-transition',
				sync: true,
				after: async(data) => {

					replaceBodyClasses(data.next);

					loadingBar.classList.remove('active');
					$(document).trigger(BrowserEvents.barba.enter);
					$('.header-wrapper').addClass('active');

					return true;
				},
				leave: async(data) => {

					const scroll = scrollPosition();

					loadingBar.classList.add('active');
					document.body.classList.add('leaving');
					data.current.container.classList.add('leaving');
					data.next.container.classList.add('from-barba');
					data.next.container.style.top = scroll.scrollTop + 'px';

					if(document.body.classList.contains('menu-open')) {
						document.body.classList.remove('menu-open');
						enableBodyScroll(menuWrapper);
					}

					await TweenMax.to(data.current.container, 1, { opacity: 0 });

					await wait(100);

					window.scrollTo(0, 0);
					data.next.container.style.top = 0;

					return true;
				},
			}]
		});

		$('.main-wrapper').animsition({
			inClass: 'fade-in',
			outClass: 'fade-out',
			inDuration: 600,
			outDuration: 400,
			loading: false,
			linkElement: 'a[href*="shop"]:not([href$="shop/"])',
		}).on('animsition.inEnd', () => {
			loadingBar.classList.remove('active');
			$('.header-wrapper').addClass('active');
		}).on('animsition.outStart', () => {
			loadingBar.classList.add('active');
		});
	}

}(jQuery));
